var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 372,
    height: 372,
    fill: "none",
    viewBox: "0 0 372 372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1C20",
    d: "M0 0h242c71.797 0 130 58.203 130 130v242H130C58.203 372 0 313.797 0 242V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M188.248 82.288h-68.4c-3.312 0-6.048 2.592-6.048 6.048v203.616c0 3.312 2.736 6.048 6.048 6.048h30.24c3.312 0 6.048-2.736 6.048-6.048V200.8l68.256 93.024A10.095 10.095 0 00232.6 298h37.008c2.736 0 4.752-2.304 4.752-4.752 0-.864-.288-1.872-1.008-2.736l-72.864-98.352c22.032-3.168 34.848-18.576 34.848-41.472 0-24.192-17.568-39.888-44.928-39.888h-40.32c-3.312 0-6.048 2.592-6.048 6.048v41.76c0 3.312 2.736 6.048 6.048 6.048s6.048-2.736 6.048-6.048v-35.712h34.272c20.016 0 32.832 9.648 32.832 27.792 0 16.128-7.776 30.384-34.272 30.384h-2.448c-2.736 0-4.752 2.16-4.752 4.608 0 1.008.288 2.016 1.008 2.88l72.144 97.344h-21.312l-73.872-100.656c-2.016-2.736-5.04-4.176-8.352-4.176h-1.296c-3.312 0-6.048 2.592-6.048 6.048v98.784h-18.144V94.384h62.352c39.456 0 65.232 21.6 65.232 56.304 0 18.864-7.056 35.568-21.312 45.648-1.728 1.152-2.736 3.024-2.736 4.896 0 3.456 2.736 6.192 6.048 6.192 1.296 0 2.448-.432 3.6-1.152 16.992-11.952 26.496-31.824 26.496-55.584 0-38.304-27.648-68.4-77.328-68.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e9307f2b1964b97e9aff0bce199fead3.svg";
export { ForwardRef as ReactComponent };